import axios from 'axios'

const api = '/umbraco/api/searchapi'

const search = `${api}/Search`
const articles = `${api}/Articles`
const daysOut = `${api}/DaysOut`
const events = `${api}/Events`
const content = `${api}/Content`
const tags = `${api}/GetTagsByParentId`
const locationTags = `${api}/GetLocationTagsByParentId`
const primarySecondaryTagsByParentId = `${api}/GetPrimarySecondaryTagsByParentId`

export function getArticlesByParentId(queries) {
    return axios.get(articles, {
        params: queries
    })
}

export function getDaysOutByParentId(queries) {
    return axios.get(daysOut, {
        params: queries
    })
}

export function getTagsByParentId(queries) {
    return axios.get(tags, {
        params: queries
    })
}

export function getPrimarySecondaryTagsByParentId(queries) {
    return axios.get(primarySecondaryTagsByParentId, {
        params: queries
    })
}

export function getSearchData(queries) {
    return axios.get(search, {
        params: queries
    })
}

export function getEventsByParentId(queries) {
    return axios.get(events, {
        params: queries
    })
}

export function getContentByParentId(queries) {
    return axios.get(content, {
        params: queries
    })
}

export function getEventTagsByParentId(queries) {
    return Promise.all([tags, locationTags].map((endpoint) => axios.get(endpoint, { params: queries})))
}
